<template>
	<div>
		<div v-bind:class="{'search-box-root': isHome}">
			<div v-bind:class="{'search-box': isHome}">
				<div class="search">
					<div class="widget-search">
						<input type="search" class="search-field" placeholder="Please input protein or peptide" v-model="condition">
						<button type="submit" class="search-submit" @click.prevent="search">
							<i class="flaticon-interface"></i>
						</button>
					</div>
				</div>
			</div>
		</div>

		<mainPic :isShowed="isHome" />

		<results :items="items" />
	</div>
</template>

<script>
	import axios from "axios"
	import Results from '../components/Results.vue'
	import mainPic from '../components/MainPic.vue'

	export default {
		components: {
			'mainPic': mainPic,
			'results': Results
		},
		data() {
			return {
				condition: '',
				isHome: true,
				items: null
			}
		},
		methods: {
			search() {
				if (this.condition.length < 5) {
					this.condition = 'The length must be greater then four!'
				} else {
					axios
						.post("/getOtherResults.do", null, {
							params: {
								condition: this.condition
							}
						})
						.then(response => {
							if (response.data.status == 0) {
								this.items = response.data.items
								this.isHome = false
							}
						})
						.catch(err => {
							console.log(err)
						})
				}
			}
		}
	}
</script>

<style>
</style>